export default __webpack_public_path__ + "static/media/WhatsApp Image3.6b3abece.jpeg";